import arrowRightIcon from './assets/arrow-right.svg'
import helloIcon from './assets/hello.png'
import { SetNicknameError } from './components/SetNicknameError'
import { useSetNickname } from './hooks/useSetNickname'

export default function SetNickname() {
  const { nickname, setNickname, isLoading, errorMessage, handleSetNickname } =
    useSetNickname()

  return (
    <div className='relative h-screen w-full bg-white px-[20px] pt-[60px] pb-[100px]'>
      <div className='flex flex-col items-center'>
        <img src={helloIcon} alt='' className='h-[120px] w-[120px]' />
        <h1 className='mt-[32px] font-black text-[28px] leading-tight text-black'>
          Set Your Nickname
        </h1>
        <p className='mt-[12px] text-center text-[16px] leading-relaxed text-black/60'>
          Choose a nickname for yourself!
        </p>
      </div>

      <div className='mt-[48px] flex flex-col gap-[24px]'>
        <div className='relative flex flex-col gap-[8px]'>
          <input
            id='nickname'
            type='text'
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder='Enter nickname'
            className='h-[56px] w-full border-b-2 border-black/10 bg-transparent text-[18px] font-medium outline-none transition-colors focus:border-[#6C5CE7]'
            data-testid='nickname-input'
          />
        </div>
      </div>

      <div className='absolute right-[20px] bottom-[40px]'>
        <button
          type='button'
          onClick={handleSetNickname}
          disabled={isLoading || !nickname.trim()}
          className='flex h-[60px] w-[60px] items-center justify-center rounded-full bg-[#6C5CE7] shadow-[0px_4px_10px_rgba(108,92,231,0.3)] transition-all active:scale-95 disabled:scale-100 disabled:cursor-not-allowed disabled:opacity-50 hover:bg-[#5b4bc4]'
          data-testid='submit-nickname-btn'
          aria-label='Submit Nickname'
        >
          {isLoading ? (
            <div className='h-[24px] w-[24px] animate-spin rounded-full border-2 border-white border-t-transparent' />
          ) : (
            <img src={arrowRightIcon} alt='' className='h-[24px] w-[24px]' />
          )}
        </button>
      </div>

      <SetNicknameError message={errorMessage} />
    </div>
  )
}
